<div class="error-handler">
    <div class="container-fluid">
        <div class="alert alert-danger col-md-12" role="alert">
            <span class="text-danger" *ngIf="!isLocal">Une erreur est survenue veuillez contacter l'administrateur!!</span>
            <span class="text-danger" *ngIf="isLocal">Désolé si vous êtes ici c'est que c'est le temps de corriger ce genre d'exception</span>
            <p style="font-size:100px" *ngIf="isLocal" class="emoji" [innerHTML]="icone | safeHtml"></p>
            <span>{{ error | translate }}</span>
        </div>
    </div>
</div>